const mileageRoutes = [
  {
    path: "/mileage",
    name: "",
    meta: {
      title: "마일리지",
      isDynamic: true,
    },
    children: [
      {
        path: "apply", // /mileage/apply
        name: "activityApplyIndex",
        meta: {
          title: "자기주도활동 신청",
          menuCd: "ACTIVITY_APPLY",
          isDynamic: true,
        },
        component: () => import("@/views/student/mileage/apply/ActivityApplyIndex.vue"),
      },
      {
        path: "history", // /mileage/history
        name: "mileageHistory",
        meta: {
          title: "마일리지 적립 현황",
          menuCd: "MILEAGE_HISTORY",
          isDynamic: true,
        },
        component: () => import("@/views/student/mileage/history/MileageHistoryIndex.vue"),
      },
    ],
  },
];
export default mileageRoutes;
